/***
 * 
 * This script hooks into iframe messages and attempts to listen and process any iFrameSize messages
 * and updates the height and width of the iFrame to have them fit the content correctly.
 */

export const initIFrameResizer = () => {
    document.querySelectorAll('iframe').forEach(iframe => {
        window.addEventListener('message', event => {
            if (typeof event.data === "string") {
                // Event data is a string, attempting to parse JSON
                try {
                    let dataObj = JSON.parse(event.data);
                    if (dataObj.type === 'IFrameSize' && event.source === iframe.contentWindow) {
                        const { Height, Width } = dataObj.data;

                        if (Height !== null && typeof Height === 'number') {
                            iframe.style.height = Height + 'px';
                        }

                        if (Width !== null && typeof Width === 'number') {
                            iframe.style.width = Width + 'px';
                        }
                    }
                } catch (e) {
                    // Do nothing, may have not been JSON
                }
            }
        });
    });
};